// 退货模块
import $http from '../../utils/http';
let refundPath;
if (process.env.NODE_ENV !== 'development') {
  refundPath = 'tio/refund/api';
} else {
  refundPath = '/refundApi';
}

// 保存拨打电话记录
export const saveOperatingRecord = data => {
  return $http({
    url: refundPath + '/refund/saveOperatingRecord  ',
    data,
    method: 'POST'
  });
};

// 获取真实号码（详情接口下发的号码已掩码/加密，拨号前需换取明文）
export const getPhone = params => {
  return $http({
    url: refundPath + '/refund/getPhone',
    params,
    isNotice: true // 由页面内 $Toast 遮罩接管，避免与全局 spinner 叠加
  });
};

export const getUserByUserId = data => {
  return $http({
    url: refundPath + '/refund/getUserByUserId',
    data,
    // isPayload: true,
    method: 'POST'
  });
};

// 获取上报机构
export const getSelfParentOrg = params => {
  return $http({
    url: refundPath + '/dict/getSelfParentOrg',
    params
  });
};

// 查看行程单
export const UrlByItineraryNo = data => {
  return $http({
    url: refundPath + '/refund/UrlByItineraryNo',
    data,
    // isPayload: true,
    method: 'POST'
  });
};

// 平均每位游客退货
export const avgTouristRefund = data => {
  return $http({
    url: refundPath + '/statistics/supervisionCenter/avgTouristRefund',
    data,
    isPayload: true,
    method: 'POST'
  });
};

// 选择渠道分布
export const appRefundChannel = data => {
  return $http({
    url: refundPath + '/statistics/app/appRefundChannel',
    data,
    isPayload: true,
    method: 'POST'
  });
};

// 退货原因分布
export const returnReasonDistribution = (data) => {
  return $http({
    url: refundPath + '/statistics/supervisionCenter/returnReasonDistribution',
    data,
    isPayload: true,
    method: 'POST'
  });
};

// 近三十天退货数量
export const appRefundNumCompare = params => {
    return $http({
        url: refundPath + '/statistics/app/appRefundNumCompare',
        params
    });
};

// 获取地区
export const regionWithSelf = (params) => {
    return $http({
        url: refundPath + '/dict/regionWithSelf',
        params
    });
};

// 处理满意度分布
export const touristEvaluation = (data) => {
  return $http({
    url: refundPath + '/statistics/supervisionCenter/touristEvaluation',
    data,
    isPayload: true,
    method: 'POST'
  });
};

// 退货商品分布情况
export const commodityType = (data) => {
  return $http({
    url: refundPath + '/statistics/supervisionCenter/commodityType',
    data,
    isPayload: true,
    method: 'POST'
  });
};

// 平均时长
export const disposalEfficiency = (data) => {
  return $http({
    url: refundPath + '/statistics/supervisionCenter/disposalEfficiency',
    data,
    isPayload: true,
    method: 'POST'
  });
};

// 首页企业去火、未取货数据
export const appCompanyPick = (params) => {
  return $http({
    url: refundPath + '/statistics/app/appCompanyPick',
    params
  });
};

// 首页退货单各处理情况数据
export const getEnterpriseWorkBenchAll = (params) => {
  return $http({
    url: refundPath + '/statistics/app/getEnterpriseWorkBenchAll',
    params
  });
};

// 关联退货单的服务点列表
export const listRelevance = (params) => {
  return $http({
    url: refundPath + '/SupervisionCenter/service/listRelevance',
    params
  });
};

// 关联退货单
export const relevance = (data) => {
  return $http({
    url: refundPath + '/refund/center/relevance',
    data,
    // isPayload: true,
    method: 'POST'
  });
};

// 累计退货
export const returnQuantityAnd = (data) => {
  return $http({
    url: refundPath + '/statistics/supervisionCenter/returnQuantityAnd',
    data,
    isPayload: true,
    method: 'POST'
  });
};

// 反馈取货信息
export const pick = (data) => {
  return $http({
    url: refundPath + '/refund/center/pick',
    data,
    method: 'POST'
  });
};

// 签协议
export const sign = (data) => {
  return $http({
    url: refundPath + '/refund/center/originate/sign',
    data,
    method: 'POST'
  });
};

// 发送验证码开关，发送验证码必须调用
export const smsSwitch = (data) => {
  return $http({
    url: refundPath + '/external/cmq/sms/switch',
    data,
    method: 'POST'
  });
};

// 验证验证码
export const verifySMS = (data) => {
  return $http({
    url: refundPath + '/refund/SMS/verify',
    data,
    method: 'POST'
  });
};

// 发送短信验证码
export const sendSMS = (data) => {
  return $http({
    url: refundPath + '/refund/SMS/send',
    data,
    method: 'POST'
  });
};

// 获取重复退货单
export const getFindRepeatOrder = (params) => {
  return $http({
    url: refundPath + '/refund/findRepeatOrder',
    params
  });
};

// ocr识别，识别图片信息
export const getIDCardInfo = (data) => {
  return $http({
    url: refundPath + '/refund/getIDCardInfo',
    data,
    method: 'POST',
    isPayload: true
  });
};

// 申诉反馈审核
export const complainFeedbackAudio = (params) => {
  return $http({
    url: refundPath + '/refund/complainFeedbackAudio',
    params,
    method: 'POST'
  });
};

// 申诉反馈
export const complainFeedback = (data) => {
  return $http({
    url: refundPath + '/refund/complainFeedback',
    data,
    method: 'POST'
  });
};

// 督办反馈
export const overseefeedback = (params) => {
  return $http({
    url: refundPath + '/supervise/supervisionFeedback',
    params
  });
};

// 获取所有企业（获取有退货处置权限的商户列表）
export const getDisposeEnterprise = (params) => {
  return $http({
    url: refundPath + '/dict/getDisposeEnterprise',
    params
  });
};

// 获取子级机构
export const getChildOrg = (params) => {
  return $http({
    url: refundPath + '/dict/getChildOrg',
    params
  });
};

// 获取服务点列表
export const servicePointList = (params) => {
  return $http({
    url: refundPath + '/SupervisionCenter/service/list',
    params
  });
};

// 退回
export const backUp = (data) => {
  return $http({
    url: refundPath + '/refund/backUp',
    data,
    method: 'POST'
  });
};

// 督办
export const supervise = (data) => {
  // 不予受理
  return $http({
    url: refundPath + '/refund/overSee/add',
    data,
    method: 'POST'
  });
};

// 获取监理中心联系人
export const getHandlerByRegionCode = (params) => {
  return $http({
    url: refundPath + '/refund/getHandlerByRegionCode',
    params
  });
};

export const currentUser = (params) => {
  // 获取首页用户信息
  return $http({
    url: refundPath + '/auth/currentUser',
    params
  });
};
export const workbench = (params) => {
  // 获取首页用户信息
  return $http({
    url: refundPath + '/refund/home/worker/workbench',
    params
  });
};
export const returnList = (params) => {
  // 获取列表信息
  return $http({
    url: refundPath + '/refund/page',
    params
  });
};
export const typePicker = (params) => {
  return $http({
    url: refundPath + '/dict/type',
    params
  });
};
// 获取监理中心联系人列表
export const getSupervisionCenterList = (params) => {
  return $http({
    url: refundPath + '/SupervisionCenter/',
    params
  });
};

// 获取服务点和处理人
export const getAcceptMessage = (params) => {
  return $http({
    url: refundPath + '/refund/acceptMessage',
    params
  });
};
export const detailList = (params) => {
  // 获取退单详情页面
  return $http({
    url: refundPath + '/refund/detail',
    params
  });
};
export const refundImg = (params) => {
  // 获取退单详情页面图片
  return $http({
    url: refundPath + '/refund/order/images',
    params
  });
};
// export const refundImg = params => {
//   // 获取退单详情页面图片
//   return $http({
//     url: refundPath + '/refund/order/images',
//     params
//   });
// };

export const notHandled = (data) => {
  // 不予受理
  return $http({
    url: refundPath + '/refund/notHandled',
    data,
    method: 'POST'
  });
};
export const lately30 = (params) => {
  // 获取当前日期前三十天数据
  return $http({
    url: refundPath + '/refund/last30day/trend',
    params
  });
};
// 获取云南省下所有的市
export const getCity = (params) => {
  return $http({
    url: refundPath + '/dict/region',
    params
  });
};
export const attention = (data) => {
  // 关注
  return $http({
    url: refundPath + '/refund/attention',
    data,
    method: 'POST'
  });
};
export const accept = (data) => {
  // 同意受理
  return $http({
    url: refundPath + '/refund/accept',
    data,
    method: 'POST'
  });
};
export const recover = (data) => {
  // 收回垫付金
  return $http({
    url: refundPath + '/refund/recover',
    data,
    method: 'POST'
  });
};

export const refundMethod1 = (data) => {
  // 变更退货方式
  return $http({
    url: refundPath + '/refund/refundMethod',
    data,
    method: 'POST'
  });
};

export const unAttention = (data) => {
  // 取消关注
  return $http({
    url: refundPath + '/refund/unAttention',
    data,
    method: 'POST'
  });
};
export const confirmReceipt = (data) => {
  // 确认收货
  return $http({
    url: refundPath + '/refund/confirmReceipt',
    data,
    method: 'POST'
  });
};
// 上报审核
export const audit = (data) => {
  // 审核信息
  return $http({
    url: refundPath + '/refund/audit',
    data,
    method: 'POST'
  });
};
// 处置结果审核
export const checkfinish = (data) => {
  // 审核信息
  return $http({
    url: refundPath + '/refund/checkfinish',
    data,
    method: 'POST'
  });
};
export const workbenchPrice = (params) => {
  // 首页企业垫付管理
  return $http({
    url: refundPath + '/refund/home/lately30AdvanceAmountTotal',
    params
  });
};
// 领导组接口
export const workbenchLeader = (params) => {
  // 领导组首页数据统计
  return $http({
    url: refundPath + '/refund/home/leader/workbench',
    params
  });
};
export const returnSort = (params) => {
  // 领导组退货数据
  return $http({
    url: refundPath + '/refund/home/leader/returnSort',
    params
  });
};
export const orderDistinguish = (params) => {
  // 变更退货方式
  return $http({
    url: refundPath + '/refund/express/orderDistinguish',
    params
  });
};

export const trackQuery = (params) => {
  // 变更退货方式
  return $http({
    url: refundPath + '/refund/express/trackQuery',
    params
  });
};
export const trend = (params) => {
  // 首页折线图
  return $http({
    url: refundPath + '/refund/home/trend',
    params
  });
};

export const track = (params) => {
  // 变更退货方式
  return $http({
    url: refundPath + '/refund/express/track',
    params
  });
};
export const address = (params) => {
  return $http({
    url: refundPath + '/refund/feedback/address',
    params,
    method: 'POST'
  });
};
// 查询用户所在监理中心默认地址
export const currentUserDefaultDeliveryAddress = (params) => {
  return $http({
    url:
      refundPath + '/refund/delivery/address/currentUserDefaultDeliveryAddress',
    params
  });
};

export const org = (params) => {
  // 转办获取下级数据列表
  return $http({
    url: refundPath + '/dict/org',
    params
  });
};

export const express = (data) => {
  // 反馈快递单号
  return $http({
    url: refundPath + '/refund/feedback/express',
    data,
    method: 'POST'
  });
};

export const fileUpload = (data) => {
  // 图片上传
  return $http({
    url: refundPath + '/attach/fileUpload',
    data,
    method: 'POST'
  });
};

export const report = (data) => {
  // 上报
  return $http({
    url: refundPath + '/refund/report',
    data,
    method: 'POST'
  });
};

export const parentOrg = (params) => {
  // 上报，获取上级部门
  return $http({
    url: refundPath + '/dict/parentOrg',
    params
  });
};

export const flow = (data) => {
  // 确认转办
  return $http({
    url: refundPath + '/refund/flow',
    data,
    method: 'POST'
  });
};
export const verify = (data) => {
  // 反馈审核信息
  return $http({
    url: refundPath + '/refund/feedback/verify',
    data,
    method: 'POST'
  });
};

// 退货同比趋势
export const visualTrend = (params) => {
  return $http({
    url: refundPath + '/refund/visual/trend',
    params
  });
};

// 退货商品类型分布情况
export const classified = (params) => {
  return $http({
    url: refundPath + '/refund/home/classified',
    params
  });
};

// 获取云南省下所有的市
export const getRegion = (params) => {
  return $http({
    url: refundPath + '/dict/region',
    params
  });
};

// 获取基础信息
export const getDictType = (params) => {
  return $http({
    url: refundPath + '/dict/type',
    params
  });
};

export const backendFileUpload = (data) => {
  // 图片上传
  return $http({
    url: '/backend/api/attach/fileUpload',
    data,
    method: 'POST',
    isPayload: true
  });
};

// 获取企业信息
export const getQueryEnterpriseList = (params) => {
  return $http({
    url: refundPath + '/supervise/queryEnterpriseList',
    params
  });
};

// 退货
export const postCreateRefund = (data) => {
  return $http({
    url: refundPath + '/refund/createRefund',
    data,
    method: 'POST'
  });
};

// 验证身份证号
export const getItineraryListByIdCard = (params) => {
  return $http({
    url: refundPath + '/refund/getItineraryListByIdCard',
    params
  });
};

// 退货区域
export const regionalReturnRanking = (data, queryType) => {
  return $http({
      // url: refundPath + '/statistics/supervisionCenter/regionalReturnRanking',
      url: `${refundPath}/statistics/supervisionCenter/regionalReturnRanking?queryType=${queryType}`,
      data,
      isPayload: true,
      method: 'POST'
  });
};

// 服务点
export const fieldService = data => {
  return $http({
      url: refundPath + '/statistics/supervisionCenter/fieldService',
      data,
      isPayload: true,
      method: 'POST'
  });
};

// 热门企业
export const hotspotReturnEnterprise = data => {
  return $http({
      url: refundPath + '/statistics/supervisionCenter/hotspotReturnEnterprise',
      data,
      isPayload: true,
      method: 'POST'
  });
};

// 退货件列表
export const getRefundList = (params, showLoading) => {
  return $http({
    url: refundPath + '/refund/page',
    params,
    showLoading
  });
};

// 游客出行方式分布
export const getTravelMode = data => {
  return $http({
      url: refundPath + '/statistics/supervisionCenter/travelMode',
      data,
      isPayload: true,
      method: 'POST'
  });
};

// 来源地分布TOP10
export const getTouristSource = data => {
  return $http({
      url: refundPath + '/statistics/supervisionCenter/touristSource',
      data,
      isPayload: true,
      method: 'POST'
  });
};

// 年龄分布情况
export const getTouristAge = data => {
  return $http({
      url: refundPath + '/statistics/supervisionCenter/touristAge',
      data,
      isPayload: true,
      method: 'POST'
  });
};

export default {
    smsSwitch,
    regionWithSelf,
    currentUser,
    getDisposeEnterprise,
    workbench,
    returnList,
    typePicker,
    detailList,
    refundImg,
    getCity,
    attention,
    getChildOrg,
    accept,
    backUp,
    refundMethod1,
    overseefeedback,
    recover,
    supervise,
    servicePointList,
    workbenchLeader,
    lately30,
    sign,
    unAttention,
    confirmReceipt,
    audit,
    workbenchPrice,
    returnSort,
    orderDistinguish,
    trackQuery,
    track,
    address,
    getIDCardInfo,
    currentUserDefaultDeliveryAddress,
    getHandlerByRegionCode,
    org,
    getAcceptMessage,
    express,
    fileUpload,
    report,
    parentOrg,
    flow,
    verify,
    trend,
    notHandled,
    classified,
    visualTrend,
    getSupervisionCenterList,
    getRegion,
    getDictType,
    backendFileUpload,
    checkfinish,
    getQueryEnterpriseList,
    postCreateRefund,
    complainFeedbackAudio,
    getItineraryListByIdCard,
    complainFeedback,
    getFindRepeatOrder,
    verifySMS,
    sendSMS,
    pick,
    returnQuantityAnd,
    relevance,
    listRelevance,
    getEnterpriseWorkBenchAll,
    appCompanyPick,
    disposalEfficiency,
    commodityType,
    touristEvaluation,
    appRefundNumCompare,
    regionalReturnRanking,
    fieldService,
    hotspotReturnEnterprise,
    touristEvaluation,
    getRefundList,
    getTravelMode,
    getTouristSource,
    getTouristAge,
    returnReasonDistribution,
    appRefundChannel,
  avgTouristRefund,
  UrlByItineraryNo,
  getSelfParentOrg,
  getUserByUserId,
  saveOperatingRecord,
  getPhone
};
